export interface IStudentDetails {
  studentId: string;
  institution: string;
  course: string;
  courseEndDate?: Date;
}
